import styled, { css, keyframes } from 'styled-components';

export const Header = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background-color: ${theme.v2.colors.white.primary};
    border-bottom: 1px solid ${theme.v2.colors.neutral.highMedium};
    display: flex;
    max-height: fit-content;
    padding: 24px;
    width: 100%;
  `}
`;

export const BackButtonWrapper = styled.div`
  ${({ theme }) => css`
    button {
      color: ${theme.v2.colors.neutral.lowMedium};
      :hover {
        color: ${theme.v2.colors.neutral.lowDark};
      }
      svg {
        width: 18px;
        height: 18px;
        @media (max-width: ${theme.v2.breakpoints.md}) {
          width: 24px;
          height: 24px;
        }
      }
    }
  `}
`;

export const HgLogo = styled.img`
  ${({ theme }) => css`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    @media (max-width: ${theme.v2.breakpoints.md}) {
      max-width: 103px;
    }
  `}
`;

export const FastCheckoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

export const AlertWrapper = styled.div`
  ${({ theme }) => css`
    > div {
      background-color: ${theme.v2.colors.neutral.highPure};
      box-shadow: 0px 0px 1px 0px #707070;
    }
    bottom: 85px;
    position: fixed;
    max-width: 469px;
    right: 62px;
    width: 100%;
    animation: ${slideIn} 0.5s ease-out;
    @media (max-width: ${theme.v2.breakpoints.sm}) {
      max-width: 300px;
      right: 20px;
    }
  `}
`;

export const LoaderWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
`;
